// LineLoader.js
import React from 'react';

export default function LineLoader() {
  return (
    <div className="line-loader">
      <div className="line"></div>
    </div>
  );
}
